var _rect, _rect2, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditorEmptyBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#F6F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 4.5,
    y: 6.5,
    width: 19,
    height: 15,
    stroke: "#4F4F4F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 18,
    height: 14
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 18,
    height: 14,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14642 4.64648L-5.35358 19.1465L-4.64647 19.8536L9.85353 5.35359L9.14642 4.64648ZM-2.35358 19.1465L12.1464 4.64648L12.8535 5.35359L-1.64647 19.8536L-2.35358 19.1465ZM15.1464 4.64648L0.646423 19.1465L1.35353 19.8536L15.8535 5.35359L15.1464 4.64648ZM1.64642 21.1465L18.1464 4.64648L18.8535 5.35359L2.35353 21.8536L1.64642 21.1465ZM21.1464 4.64648L4.64642 21.1465L5.35353 21.8536L21.8535 5.35359L21.1464 4.64648ZM24.1464 4.64648L7.64642 21.1465L8.35353 21.8536L24.8535 5.35359L24.1464 4.64648ZM27.1464 4.64648L10.6464 21.1465L11.3535 21.8536L27.8535 5.35359L27.1464 4.64648ZM30.1464 4.64648L13.6464 21.1465L14.3535 21.8536L30.8535 5.35359L30.1464 4.64648ZM19.6464 21.1465L36.1464 4.64648L36.8535 5.35359L20.3535 21.8536L19.6464 21.1465ZM16.6464 21.1465L33.1464 4.64648L33.8535 5.35359L17.3535 21.8536L16.6464 21.1465Z",
    fill: "#4F4F4F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorEmptyBlock);
export default __webpack_public_path__ + "static/media/editor-empty-block.3bdb0dcf9c5f65502f80b932d40bc859.svg";
export { ForwardRef as ReactComponent };